import { render, staticRenderFns } from "./RirekishoJobHistoryCard.vue?vue&type=template&id=4240720f&scoped=true"
import script from "./RirekishoJobHistoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoJobHistoryCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RirekishoJobHistoryCard.vue?vue&type=style&index=0&id=4240720f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4240720f",
  null
  
)

export default component.exports